<template>
<div>
    <span :class="debtStatusText == '待补款'?'red':''">{{debtStatusText}}</span>
    <el-button v-if="isEditing" icon="el-icon-circle-plus" class="margin-left-10" size="small" type="text" @click="openContinuePaymentDialog()"></el-button>
    <el-button v-if="isEditing" icon="el-icon-circle-close" class="gray" size="small" type="text" @click="Reset()"></el-button>
</div>
</template>

<style lang="scss" scoped>
.red { color: red}
.course-price-list-area {
    margin-right: 2px;
    padding: 30px, 30px, 30px, 30px;
}

.add-payment-button {
    margin-bottom: 10px;
}

.gray {
    color: gray;
    margin-left: 3px;
}

.margin-left-10 {
    margin-left: 10px;
}
</style>

<script>
import {
    saveCommentsChange
} from "../../../service/finance.service.js";
import {
    formatDate,
    getStore
} from "../../../config/mUtils.js"; 
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {}
    },
    data() { 
        return { 
            debtStatusText: undefined,
            isEditing: false, 
        };
    },
    components: { 
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.debtStatusText = this.data.DebtStatus;
            this.originalDebtStatusText = this.debtStatusText;
        },
        openContinuePaymentDialog() {
            this.$router.push({
                path: "/frontDesk/salesQueryContinuePayment",
                query: {
                    workflowId: this.data.WorkflowId,
                    studentId:this.data.StudentId
                }
            });
        },
        Reset() {
            this.isEditing = false;
            this.debtStatusText = this.originalDebtStatusText;
        },
        onPaymentEditorClose() {
            this.paymentEditorVisible = false;
        },
         
    },
    watch: {
        editLocation: function () {
            if (this.data.IsRefund){
                return;
            }
            
            if (
                this.editLocation &&
                this.editLocation.columnLabel == "状态" && this.data.DebtStatus == "待补款" &&
                this.editLocation.rowIndex == this.data.Index
            ) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },
        data: function () {
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/saleQueryContinuePaymentCell.vue